import React from 'react';
import { Container, Row, Col, Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { useTranslator } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';
import LanguageChange from './LanguageChange';

const FooterSimple = () => {
  const { t, language } = useTranslator();
  const year = new Date().getFullYear();

  const {
    navigation: { footerNavigation },
  } = useAppContext();

  return (
    <footer className="py-xl footer-simple">
      <Container>
        <Row className="align-items-center">
          <Col md="8" className="text-center text-md-start d-md-flex">
            <div className="me-3 d-none d-md-block">
              <LanguageChange displayLangName={true} />
            </div>
            <Nav className="flex-column flex-md-row">
              {footerNavigation.map(
                (item: { path?: string; translationKey: string; externalPath?: any }) => {
                  if (item.externalPath) {
                    if (typeof item.externalPath === 'object') {
                      return (
                        <a
                          href={item.externalPath[language]}
                          className="nav-link p-md-0 me-md-xl"
                          style={{ lineHeight: '24px' }}
                          key={item.translationKey}
                        >
                          {t(item.translationKey)}
                        </a>
                      );
                    }
                    return (
                      <a
                        href={item.externalPath}
                        className="nav-link p-md-0 me-md-xl"
                        style={{ lineHeight: '24px' }}
                        key={item.translationKey}
                      >
                        {t(item.translationKey)}
                      </a>
                    );
                  }
                  return (
                    <NavItem key={item.translationKey} className="me-md-xl">
                      <NavLink
                        to={item.path || '#'}
                        className="nav-link p-md-0"
                        style={{ lineHeight: '24px' }}
                      >
                        {t(item.translationKey)}
                      </NavLink>
                    </NavItem>
                  );
                }
              )}
            </Nav>

            <div className="my-3 d-md-none">
              <LanguageChange displayLangName={true} />
            </div>
          </Col>

          <Col xs={{ size: 12, order: 1 }} md={{ size: 4, order: 2 }}>
            <hr className="d-md-none my-sm" />
            <p className="description text-center text-md-end mb-0">
              Copyright ©2021-{year} activerse.app
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default FooterSimple;
